import React, { useState } from 'react';
import { LandingNav } from '../components/landing/LandingNav';
import { LandingHero } from '../components/landing/LandingHero';
import { LandingSteps } from '../components/landing/LandingSteps';
import { LandingCta } from '../components/landing/LandingCta';
import { LandingFooter } from '../components/landing/LandingFooter';
import { LogoStrip } from '../components/LogoStrip';
import { SignupAudience } from '../types/signup';
export function Landing() {
  const [audience, setAudience] = useState<SignupAudience>('gigs');
  const goToSignup = (a: SignupAudience) => {
    setAudience(a);
    document.getElementById('signup')?.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  };
  return <div className="min-h-screen w-full bg-canvas text-ink" data-id="element-332" data-mp="c84aqmkra5di">
      <LandingNav onSignup={goToSignup} data-id="element-333" data-mp="h8qys5ds10qy" />
      <main data-id="element-334" data-mp="h9tqgfixb77x">
        <LandingHero audience={audience} onAudienceChange={setAudience} data-id="element-335" data-mp="habsxtw6ihoa" />
        <LogoStrip data-id="element-336" data-mp="m8mz9un9ma1r" />
        <LandingSteps data-id="element-337" data-mp="m7v5mpd8ame4" />
        <LandingCta onSignup={goToSignup} data-id="element-338" data-mp="m58xoomfe4vd" />
      </main>
      <LandingFooter data-id="element-339" data-mp="2atkipzxufgy" />
    </div>;
}